let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ib2WH")).then(() => parcelRequire('8OhI4'));